export default function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime/helpers/esm/arrayWithHoles.js
// module id = 768
// module chunks = 121